import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recent-news',
  templateUrl: './recent-news.component.html',
  styleUrls: ['./recent-news.component.scss'],
})
export class RecentNewsComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  irAlMenu(): void {
    this.router.navigateByUrl('/menu');
  }
}
